Wee.fn.make('storage', {
	_construct: function(options) {
		var store = options.store || 'session';

		if (store === 'session') {
			this.store = sessionStorage;
		} else if (store === 'local') {
			this.store = localStorage;
		}

		this.$private.store = this.store;
	},
	get: function(key) {
		var priv = this.$private,
			segs = key.toString().split('.'),
			data = priv.getItem(segs.shift());

		segs.forEach(function(key) {
			data = data.hasOwnProperty(key) ?
				data[key] : null;
		});

		return data;
	},
	set: function(key, val) {
		var priv = this.$private,
			segs = key.toString().split('.'),
			firstKey = segs.shift(),
			origData,
			data,
			i;

		// Set item directly if no dot notation
		if (! segs.length) {
			return priv.setItem(firstKey, val);
		}

		origData = priv.getItem(firstKey);

		if (! origData) {
			origData = priv.isNumber(segs[0]) ? [] : {};
		}

		i = 0;
		data = origData;

		while (i < segs.length - 1) {
			key = segs[i];

			if (data.hasOwnProperty(key)) {
				data = data[key];
			} else {
				if (segs[i + 1]) {
					if (priv.isNumber(segs[i + 1])) {
						data[key] = [];
					} else {
						data[key] = {};
					}

					data = data[key];
				}
			}

			i++;
		}

		data[segs.pop()] = val;

		priv.setItem(firstKey, origData);

		return this.get(firstKey);
	},
	push: function(key, value) {
		var priv = this.$private,
			segs = key.toString().split('.'),
			firstKey = segs.shift(),
			origData = priv.getItem(firstKey),
			data = origData;

		segs.forEach(function(key) {
			data = data.hasOwnProperty(key) ?
				data[key] : null;
		});

		data.push(value);

		this.set(firstKey, origData);
	},
	drop: function(key) {
		var priv = this.$private,
			segs = key.toString().split('.'),
			firstKey = segs.shift(),
			origData = priv.getItem(firstKey),
			i = 0,
			data = origData;

		if (! segs.length) {
			return priv.removeItem(firstKey);
		}

		while (i < segs.length - 1) {
			key = segs[i];

			data = data.hasOwnProperty(key) ?
				data[key] : null;
		}

		delete data[segs.pop()];

		this.set(firstKey, origData);
	}
}, {
	getItem: function(key) {
		var data = this.store.getItem(key);

		return ! data ? null : JSON.parse(data);
	},
	setItem: function(key, value) {
		this.store.setItem(key, JSON.stringify(value));
	},
	removeItem: function(key) {
		this.store.removeItem(key);
	},
	isNumber: function(val) {
		return ! isNaN(parseInt(val));
	}
}, {
	instance: false
});